import { stringIncludesInsensitiveAccents } from '../../utils/normalizeForSearch';

/**
 * Filter personal views options by search
 * - Case-insensitive and accent-insensitive
 * - Matches on option.lib and option.optGroup
 * @param {Array<ApiManagerPersonalViewsOption>} personalViewsOptions - The personal views options
 * @param {string} search - The search string
 * @returns {Array<ApiManagerPersonalViewsOption>} Filtered personal views options
 */
export function searchInColumnsGroups(personalViewsOptions, search) {
  if (!Array.isArray(personalViewsOptions)) return [];
  const searchTrimmed = (search || '').trim();
  if (!searchTrimmed) return personalViewsOptions;

  return personalViewsOptions.filter((option) => {
    const libMatch = stringIncludesInsensitiveAccents(option.lib, searchTrimmed);
    const optGroupMatch = stringIncludesInsensitiveAccents(option.optGroup, searchTrimmed);
    return libMatch || optGroupMatch;
  });
}

/**
 * Find the selected personal view item
 * @param {Array<ApiManagerPersonalViewsOption>} personalViewsOptions - The personal views options
 * @param {string} selectedPersonalView - The selected personal view
 * @returns {ApiManagerPersonalViewsOption | null} The selected personal view item
 */
export const findSelectedPersonalViewItem = (personalViewsOptions, selectedPersonalView) => {
  if (!selectedPersonalView || !personalViewsOptions?.length) return null;

  const foundItem = personalViewsOptions.find(
    (personalViewOption) => personalViewOption.id === selectedPersonalView,
  );

  return foundItem || null;
};

/**
 * Find the default personal view item
 * @param {Array<ApiManagerPersonalViewsOption>} personalViewsOptions - The personal views options
 * @param {string} defaultPersonalView - The default personal view
 * @returns {ApiManagerPersonalViewsOption | null} The default personal view item
 */
export const findDefaultPersonalViewItem = (personalViewsOptions, defaultPersonalView) => {
  if (!defaultPersonalView || !personalViewsOptions?.length) return null;

  const foundItem = personalViewsOptions.find(
    (personalViewOption) => personalViewOption.id === defaultPersonalView,
  );

  return foundItem || null;
};
